import type { Upsell } from '@alltrails/types/Upsell';

type Params = {
  isPromoEligible: boolean;
  serverUpsellContent?: Upsell;
};

// Reads the server-driven content for a generic upsell. Every field is undefined when the payload omits it,
// so callers keep their local content field by field.
const getServerUpsellCopy = ({ isPromoEligible, serverUpsellContent }: Params) => {
  const header = serverUpsellContent?.components?.find(component => component.header?.type === 'standard')?.header;
  // `caption` and `primaryButtonText` are single-value, so the footer variant is resolved here.
  const footer = serverUpsellContent?.footer?.[isPromoEligible ? 'trialEligible' : 'fullPrice'];
  // The feature list arrives as its own component entry. An empty list is a deliberate "show no
  // features", so it has to survive as `[]` rather than collapse into undefined.
  const features = serverUpsellContent?.components?.find(component => component.subscriptionFeatures != null)?.subscriptionFeatures;

  return {
    ctaText: footer?.ctaButtonCopy,
    heading: header?.fullPrice?.staticTitle,
    promoEligibleHeading: header?.trialEligible?.staticTitle,
    promoEligibleSubheading: header?.trialEligible?.staticSubtitle,
    subCopy: footer?.subCopy,
    subheading: header?.fullPrice?.staticSubtitle,
    subscriptionFeatures: features
  };
};

export default getServerUpsellCopy;
